import { FormBuilder } from "components/FormBuilder/FormBuilder"
import React from 'react'
import { useTranslation } from "react-i18next";

/**
 * @param {Object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {boolean} props.isCreate
 * @param {boolean} props.isEditing
 * @param {boolean} props.isLoading
 */
const OnlineMerchantManagementCheckoutConfigSection = ({
  formProps,
  isCreate,
  isEditing,
  isLoading
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.merchant.checkoutConfigSection" });
  const { t: tCommon } = useTranslation();

  const isDisabled = isLoading;
  const isReadOnly = !isCreate && !isEditing;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    merchantLogo: {
      fieldType: "imagePicker",
      fieldName: "base64EncodedImg",
      label: tLocal("label.merchantLogo"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        allowedMimeTypes: ["image/jpeg", "image/png"],
        maxSize: 2 * 1024 * 1024,
      }
    },
    homepageUrl: {
      fieldType: "textInput",
      fieldName: "homepage_url",
      label: tLocal("label.homepageUrl"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        rules: ["validUrl"]
      }
    },
    themeColor: {
      fieldType: "colorPicker",
      fieldName: "theme_color",
      label: tLocal("label.themeColor"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        placeholder: "#007bff",
        colorType: "hex",
      }
    },
    countDown: {
      fieldType: "textInput",
      fieldName: "count_down",
      label: tLocal("label.countDown"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        inputType: "number",
        defaultValue: "1000",
        rules: [
          "onlyInteger"
        ]
      }
    },
    callbackCountdown: {
      fieldType: "textInput",
      fieldName: "callback_countdown",
      label: tLocal("label.callbackCountdown"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        inputType: "number",
        defaultValue: "30",
        rules: [
          "onlyInteger"
        ]
      }
    },

    base64EncodedTermsPdf: {
      fieldType: "filePicker",
      fieldName: "base64EncodedTermsPdf",
      label: tLocal("label.base64EncodedTermsPdf"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        allowedMimeTypes: ["application/pdf"],
        maxSize: 5 * 1024 * 1024,
        allowPreview: true,
      }
    },

    isBoxsPayMerchant: {
      fieldType: "checkbox",
      fieldName: "isBoxsPayMerchant",
      label: tLocal("label.isBoxsPayMerchant"),
      disabled: isDisabled,
      readOnly: isReadOnly,
    },
    zeroPlan: {
      fieldType: "checkbox",
      fieldName: "zeroPlan",
      label: tLocal("label.zeroPlan"),
      disabled: isDisabled,
      readOnly: isReadOnly,
    }
  }

  return (
    <FormBuilder.Section
      title={tLocal("title")}
      titleVariant="h3"
    >
      <FormBuilder.Row itemsPerRow={1}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: [
              fieldsConfig.merchantLogo,
            ]
          })
        }
      </FormBuilder.Row>
      <FormBuilder.Row itemsPerRow={2}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: [
              fieldsConfig.homepageUrl,
              fieldsConfig.themeColor,
              fieldsConfig.countDown,
              fieldsConfig.callbackCountdown,
              fieldsConfig.base64EncodedTermsPdf,
              fieldsConfig.isBoxsPayMerchant,
              fieldsConfig.zeroPlan
            ]
          })
        }
      </FormBuilder.Row>
    </FormBuilder.Section>
  )
}

export default OnlineMerchantManagementCheckoutConfigSection